import { z } from 'zod';

/**
 * Admin role ladder. `requireAdmin(min)` on the API ranks these
 * (support < moderator < superadmin). Admin is a **web-only** surface — the
 * mobile clients ship the user contract and never import from `admin/`.
 */
export const AdminRoleSchema = z.enum(['superadmin', 'moderator', 'support']);
export type AdminRole = z.infer<typeof AdminRoleSchema>;
